
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { useState } from 'react';
import { Playground, PropsTable } from 'docz';
import LikeButton from '../shared/components/LikeButton.js'
import '../shared/css/index.css'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"likebutton"}}>{`LikeButton`}</MDXTag>
<Playground __position={0} __code={'<LikeButton liked />\n<LikeButton />'} __scope={{props: this ? this.props : props,useState,LikeButton}}>
  <LikeButton liked/>
  <LikeButton />
</Playground>
<PropsTable of={LikeButton} />
<MDXTag name="h2" components={components} props={{"id":"real-life-example"}}>{`Real life example`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import React, { useState } from 'react';
import LikeButton from '/shared/components/LikeButton'

const App = props => {
  const [liked, setLike] = useState(props.liked || false);

  return (
    <LikeButton
      size={30}
      {...(liked ? {liked: true} : {liked: false})}
      onClick={() => setLike(!liked)}
    />
  );
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  